function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Array, JSON, Object, String) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['selection-segments'] = function(selectionLayout, selectionClass) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (selectionLayout.segments);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, segment, $index) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "style": {
                    'background': $helpers.getSelectionSegmentBackground(segment),
                    'grid-row': segment.rowStart,
                    'grid-column': `${segment.columnStart}` + ` / ` + `span ${segment.columnSpan}`,
                    /* weird jade parsing bug occurs without the manual string concat here */
                    'margin': `${segment.verticalMarginPx}px 0`,
                  },
                  "class": Object.assign({}, {
                    'start-rounded': segment.startRounded,
                    'end-rounded': segment.endRounded,
                    [selectionClass || undefined]: !!selectionClass,
                  }, {
                    'selection-segment': true
                  }),
                }));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var $index = $$objKey;
                if ($$obj.hasOwnProperty($index)) {
                  $$iterated = true;
                  var segment = $$obj[$index];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "style": {
                        'background': $helpers.getSelectionSegmentBackground(segment),
                        'grid-row': segment.rowStart,
                        'grid-column': `${segment.columnStart}` + ` / ` + `span ${segment.columnSpan}`,
                        /* weird jade parsing bug occurs without the manual string concat here */
                        'margin': `${segment.verticalMarginPx}px 0`,
                      },
                      "class": Object.assign({}, {
                        'start-rounded': segment.startRounded,
                        'end-rounded': segment.endRounded,
                        [selectionClass || undefined]: !!selectionClass,
                      }, {
                        'selection-segment': true
                      }),
                    }));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })());;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "attrs": __vjadeStringifyAttrsIfObj({
          elref: `scrollContainer`,
        }),
        "hook": {
          postpatch: $helpers.handleScrollContainerPostpatch,
        },
        "on": {
          mousedown: $helpers.handleScrollContainerMousedown,
        },
        "class": {
          'scroll-container': true
        },
      }, (function() {
        var __jade_nodes = []; /* having a .content-wrapper also has the additional purpose of working around a weird Safari bug with position-sticky (breaks when more than one child div) */ ;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'content-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          const weekdayLabels = $helpers.getOrderedWeekdayLabels();;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'header-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                'height': `${$helpers.HEADER_HEIGHT_PX}px`,
                'grid-template-columns': `repeat(7, ${$helpers.ROW_HEIGHT_PX}px)`,
              },
              "class": {
                'week-header': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (weekdayLabels);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, label, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'weekday-heading': true
                        },
                      }, [__vjadeSafeCode(label)]));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var label = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'weekday-heading': true
                            },
                          }, [__vjadeSafeCode(label)]));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'grid-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            const monthGridLayout = $helpers.getVisibleMonthGridLayout();;
            __jade_nodes = __jade_nodes.concat(h("div", {
              "style": {
                'grid-template-rows': `repeat(${monthGridLayout.rowHeight}, ${$helpers.ROW_HEIGHT_PX}px)`,
                'grid-template-columns': `repeat(7, ${$helpers.ROW_HEIGHT_PX}px)`,
              },
              "on": {
                /* delegate click handling to avoid adding/removing many event listeners and mass lambda creation */
                'click': $helpers.handleDelegatedClickHandler,
              },
              "hook": {
                /* snabbdom does not support event handlers that use capture, so we do it manually in hooks */
                insert: (vnode) => {
                  vnode.elm.addEventListener(`mouseenter`, $helpers.handleDelegatedMouseEnterHandler, true);
                  vnode.elm.addEventListener(`mouseleave`, $helpers.handleDelegatedMouseLeaveHandler, true);
                },
                destroy: (vnode) => {
                  vnode.elm.removeEventListener(`mouseenter`, $helpers.handleDelegatedMouseEnterHandler, true);
                  vnode.elm.removeEventListener(`mouseleave`, $helpers.handleDelegatedMouseLeaveHandler, true);
                },
              },
              "class": {
                'month-grid': true
              },
            }, (function() {
              var __jade_nodes = []; /* canary elements are invisible, they exist to be watched by IntersectionObserver; */ ; /* when a canary element scrolls into view, it's a sign that more calendar months need to be loaded */ ;
              __jade_nodes = __jade_nodes.concat(h("div", {
                "key": "top-canary",
                "style": {
                  'grid-row': `1 / span ${monthGridLayout.topCanaryRowStart}`,
                },
                "hook": {
                  insert: $helpers.handleTopCanaryInsert
                },
                "class": {
                  'canary': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "key": "bottom-canary",
                "style": {
                  'grid-row': `${monthGridLayout.bottomCanaryRowStart}` + ` / ` + `span ${monthGridLayout.rowHeight - monthGridLayout.bottomCanaryRowStart}`,
                  /* weird jade parsing bug occurs without the manual string concat here */
                },
                "hook": {
                  insert: $helpers.handleBottomCanaryInsert
                },
                "class": {
                  'canary': true
                },
              }));
              const selectionLayout = $helpers.getSelectionLayout();;
              __jade_nodes = __jade_nodes.concat((selectionLayout) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['selection-segments'].call(this, selectionLayout, null));;
                return __jade_nodes
              }).call(this)) : undefined);
              const previewSelectionLayout = $helpers.getPreviewSelectionLayout();;
              __jade_nodes = __jade_nodes.concat((previewSelectionLayout) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['selection-segments'].call(this, previewSelectionLayout, `preview`));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (Array.from(monthGridLayout.months.values()));
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, month, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "style": {
                          'grid-row': `${month.rowStart}`,
                        },
                        "class": {
                          'month-label': true
                        },
                      }, [__vjadeSafeCode(month.label)]));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var month = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              'grid-row': `${month.rowStart}`,
                            },
                            "class": {
                              'month-label': true
                            },
                          }, [__vjadeSafeCode(month.label)]));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })()); /* ensure that days are rendered last so they are naturally at the top of DOM stack (relevant for appearance and .month-grid click delegation) */ ;
              const todayKey = $helpers.getTodayKey();;
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (Array.from(monthGridLayout.days.keys()));
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, dayKey, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const day = monthGridLayout.days.get(dayKey);; /* this container div exists to tessellate neatly because the circular decorations leave a lot of gaps */ ;
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "key": dayKey /* not strictly necessary but it gets rid of visual flashes when snabbdom tries to reuse elements */ ,
                        "attrs": __vjadeStringifyAttrsIfObj({
                          elref: `cell_${day.columnStart}_${day.rowStart}`,
                        }),
                        "style": {
                          'grid-column': `${day.columnStart}`,
                          'grid-row': `${day.rowStart}`,
                        },
                        "props": {
                          calendarDay: day.calendarDay,
                          /* used in .month-grid delegated event handlers */
                        },
                        "class": Object.assign({}, {
                          'disabled': day.disabled
                        }, {
                          'day-of-month-square-container': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        const selectionSegment = $helpers.getSelectionSegmentForDayKey(dayKey, selectionLayout);;
                        const previewSelectionSegment = $helpers.getSelectionSegmentForDayKey(dayKey, previewSelectionLayout);;
                        const segmentType = (previewSelectionSegment || selectionSegment) && (previewSelectionSegment || selectionSegment).segmentType;;
                        const isToday = todayKey === dayKey;;
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "attrs": __vjadeStringifyAttrsIfObj(isToday ? {
                            'data-text': day.calendarDay.isoDayOfMonth
                          } : {} /* data-text used in CSS ::after content */ ),
                          "class": Object.assign({}, {
                            'today': isToday,
                            'preview-segment': !!previewSelectionSegment,
                            'segment-highlight': segmentType === $helpers.SelectionSegmentType.Highlight,
                            'segment-offset': segmentType === $helpers.SelectionSegmentType.Offset,
                            'segment-fill': segmentType === $helpers.SelectionSegmentType.Fill,
                          }, {
                            'day-of-month': true
                          }),
                        }, [__vjadeSafeCode(day.calendarDay.isoDayOfMonth)]));
                        __jade_nodes = __jade_nodes.concat($helpers.renderDayTooltip(day.calendarDay));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var dayKey = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          const day = monthGridLayout.days.get(dayKey);; /* this container div exists to tessellate neatly because the circular decorations leave a lot of gaps */ ;
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "key": dayKey /* not strictly necessary but it gets rid of visual flashes when snabbdom tries to reuse elements */ ,
                            "attrs": __vjadeStringifyAttrsIfObj({
                              elref: `cell_${day.columnStart}_${day.rowStart}`,
                            }),
                            "style": {
                              'grid-column': `${day.columnStart}`,
                              'grid-row': `${day.rowStart}`,
                            },
                            "props": {
                              calendarDay: day.calendarDay,
                              /* used in .month-grid delegated event handlers */
                            },
                            "class": Object.assign({}, {
                              'disabled': day.disabled
                            }, {
                              'day-of-month-square-container': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            const selectionSegment = $helpers.getSelectionSegmentForDayKey(dayKey, selectionLayout);;
                            const previewSelectionSegment = $helpers.getSelectionSegmentForDayKey(dayKey, previewSelectionLayout);;
                            const segmentType = (previewSelectionSegment || selectionSegment) && (previewSelectionSegment || selectionSegment).segmentType;;
                            const isToday = todayKey === dayKey;;
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "attrs": __vjadeStringifyAttrsIfObj(isToday ? {
                                'data-text': day.calendarDay.isoDayOfMonth
                              } : {} /* data-text used in CSS ::after content */ ),
                              "class": Object.assign({}, {
                                'today': isToday,
                                'preview-segment': !!previewSelectionSegment,
                                'segment-highlight': segmentType === $helpers.SelectionSegmentType.Highlight,
                                'segment-offset': segmentType === $helpers.SelectionSegmentType.Offset,
                                'segment-fill': segmentType === $helpers.SelectionSegmentType.Fill,
                              }, {
                                'day-of-month': true
                              }),
                            }, [__vjadeSafeCode(day.calendarDay.isoDayOfMonth)]));
                            __jade_nodes = __jade_nodes.concat($helpers.renderDayTooltip(day.calendarDay));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;